"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author Eric MORAND <eric.morand@gmail.com>
 */
class TwingProfilerDumperBlackfire {
    dump(profile) {
        let data = new Map();
        this.dumpProfile('main()', profile, data);
        this.dumpChildren('main()', profile, data);
        let start = `${new Date().getTime() / 1000}`;
        let str = `file-format: BlackfireProbe
cost-dimensions: wt mu pmu
request-start: ${start}

`;
        for (let [name, values] of data) {
            str += `${name}//${values['ct']} ${values['wt']} ${values['mu']} ${values['pmu']}\n`;
        }
        return str;
    }
    dumpChildren(parent, profile, data) {
        let name;
        for (let p of profile.getProfiles()) {
            if (p.isTemplate()) {
                name = p.getTemplate();
            }
            else {
                name = `${p.getTemplate()}::${p.getType()}(${p.getName()})`;
            }
            this.dumpProfile(`${parent}==>${name}`, p, data);
            this.dumpChildren(name, p, data);
        }
    }
    dumpProfile(edge, profile, data) {
        if (data.has(edge)) {
            let edgeObject = data.get(edge);
            edgeObject['ct'] += 1;
            edgeObject['wt'] += Math.floor(profile.getDuration() * 1000000);
            edgeObject['mu'] += profile.getMemoryUsage();
            edgeObject['pmu'] += profile.getPeakMemoryUsage();
        }
        else {
            data.set(edge, {
                'ct': 1,
                'wt': Math.floor(profile.getDuration() * 1000000),
                'mu': profile.getMemoryUsage(),
                'pmu': profile.getPeakMemoryUsage(),
            });
        }
    }
}
exports.TwingProfilerDumperBlackfire = TwingProfilerDumperBlackfire;
